module.exports = __webpack_public_path__ + "static/media/icon_menu_help.3b80977c.svg";